import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rl-float-form',
  templateUrl: './float-form.component.html',
  styleUrls: ['./float-form.component.scss', './float-form.component-rtl.css']
})
export class FloatFormComponent{

  @Input() closable : boolean;

}
